var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t\t.Delete-st0 {\r\n\t\t\tfill: currentColor;\r\n\t\t}\r\n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "Delete-st0",
    d: "M10.7,0.9c0-0.2-0.1-0.5-0.3-0.7C10.3,0.1,10,0,9.8,0H6.2C6,0,5.7,0.1,5.6,0.3C5.4,0.5,5.3,0.7,5.3,0.9v0.4 h5.3V0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Delete-st0",
    d: "M15.2,1.9h-4.5v0H5.3v0H0.8c-0.2,0-0.3,0.1-0.3,0.3s0.1,0.3,0.3,0.3h0.9l0.6,12.6c0,0.2,0.1,0.4,0.3,0.6 C2.8,15.9,3,16,3.2,16h9.5c0.2,0,0.5-0.1,0.6-0.3c0.2-0.2,0.3-0.4,0.3-0.6l0.5-12.6h1c0.2,0,0.3-0.1,0.3-0.3 C15.5,2.1,15.3,1.9,15.2,1.9L15.2,1.9z M5.3,13.9c0,0.2-0.1,0.3-0.3,0.3s-0.3-0.1-0.3-0.3v-10c0-0.2,0.1-0.3,0.3-0.3 s0.3,0.1,0.3,0.3V13.9z M8.3,13.9c0,0.2-0.1,0.3-0.3,0.3s-0.3-0.1-0.3-0.3v-10c0-0.2,0.1-0.3,0.3-0.3s0.3,0.1,0.3,0.3V13.9z  M11.2,13.9c0,0.2-0.1,0.3-0.3,0.3c-0.2,0-0.3-0.1-0.3-0.3v-10c0-0.2,0.1-0.3,0.3-0.3c0.2,0,0.3,0.1,0.3,0.3V13.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.67f732f1734868765a3d535955b8aae3.svg";
export { ForwardRef as ReactComponent };